import { BaseAIAdapter, AIAdapterResponse } from './AIAdapter';
import { aiConfig } from '../config/ai';

export class PerplexityAdapter extends BaseAIAdapter {
  readonly system = 'perplexity' as const;
  readonly name = 'Perplexity';
  protected apiKey: string;
  private model: string;

  constructor() {
    super();
    this.apiKey = aiConfig.perplexity.apiKey;
    this.model = aiConfig.perplexity.model;
  }

  async query(prompt: string): Promise<AIAdapterResponse> {
    if (!this.isConfigured()) {
      throw new Error('Perplexity adapter is not configured. Please provide an API key.');
    }

    try {
      const response = await fetch('https://api.perplexity.ai/chat/completions', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${this.apiKey}`,
        },
        body: JSON.stringify({
          model: this.model,
          messages: [
            {
              role: 'user',
              content: prompt,
            },
          ],
        }),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.error?.message || `HTTP ${response.status}`);
      }

      const data = await response.json();
      const text = data.choices[0]?.message?.content || '';

      // Perplexity provides citations
      const sources = data.citations || [];

      return {
        rawText: text,
        modelVersion: data.model,
        timestamp: new Date(),
        sources,
      };
    } catch (error: any) {
      this.handleError(error, 'Perplexity');
    }
  }

  getCacheTTL(): number {
    // Web-grounded - shorter cache (4-6 hours)
    return 4 * 60 * 60 * 1000;
  }
}
